import React from 'react'
import moment from 'moment'

function ViewSalesRegister({ SalesRegisterData = {} }) {
  const details = SalesRegisterData.SalesRegisterDetails || [];
  return (
    <>
      <div className="row">
        <div className="col-6 mb-3">
          <label className="form-label">Customer Name</label>
          <input type="text" className="form-control" value={SalesRegisterData.CustomerName || ''} disabled />
        </div>
        <div className="col-6 mb-3">
          <label className="form-label">Mobile Number</label>
          <input type="text" className="form-control" value={SalesRegisterData.MobileNumber || ''} disabled />
        </div>
        <div className="col-6 mb-3">
          <label className="form-label">Sales Date</label>
          <input
            type="text"
            className="form-control"
            value={SalesRegisterData.SalesDate ? moment(SalesRegisterData.SalesDate).format('MM/DD/YYYY') : ''}
            disabled
          />
        </div>
        <div className="col-6 mb-3">
          <label className="form-label">Remarks</label>
          <input type="text" className="form-control" value={SalesRegisterData.Remarks || ''} disabled />
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Vehicle</th>
              <th>Payment Type</th>
              <th className="text-end">Vehicle Cost</th>
              <th className="text-end">Down Payment</th>
              <th className="text-end">EMI</th>
            </tr>
          </thead>
          <tbody>
            {details.length === 0 ? (
              <tr><td colSpan={5} className="text-center text-muted">No items</td></tr>
            ) : details.map((d, idx) => (
              <tr key={idx}>
                <td>{d.VehicleLabel || d.VehicleId}</td>
                <td>{d.PaymentType}</td>
                <td className="text-end">{d.VehicleCost}</td>
                <td className="text-end">{d.DownPayment}</td>
                <td className="text-end">{d.EMIAmount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default ViewSalesRegister